export const QUERY_KEYS = {
  mentorProfile: 'mentoring-mentor-profile',
  mentorProfileFromUser: 'mentoring-mentor-profile-from-user',
  menteeProfileFromUser: 'mentoring-mentee-profile-from-user',
  program: 'mentoring-program-infos',
  relationship: 'mentoring-relationship',
  mentorsCustomAttributes: 'mentoring-mentors-custom-attributes',
  menteesCustomAttributes: 'mentoring-mentees-custom-attributes',
} as const;

export const MENTORING_PROFILE_STATUS = {
  pending: s__('Mentoring|Pending'),
  rejected_cannot_reapply: s__('Mentoring|Rejected cannot reapply'),
  rejected_can_reapply: s__('Mentoring|Rejected can reapply'),
  accepted: s__('Mentoring|Accepted & available'),
  terminated: s__('Mentoring|Terminated'),
  on_pause: s__('Mentoring|On pause'),
} as const;

export const RELATIONSHIP_STATUS = {
  accepted: s__('Mentoring|Active'),
  pending: s__('Mentoring|Pending'),
  rejected: s__('Mentoring|Rejected'),
  terminated: s__('Mentoring|Available'),
} as const;

export const NO_RELATIONSHIP_STATUS = s__('Mentoring|Available');

export const MENTOR_LABEL = s__('Mentoring|Mentor');
export const MENTEE_LABEL = s__('Mentoring|Mentee');
